module.exports = __webpack_public_path__ + "img/kids-bg.a4ef57ac.jpeg";